import ReactDOM from 'react-dom';
import { isEnabled } from '@bamboohr/utils/lib/feature';
import { renderV2 } from 'base/wrapped-render-v2';
import { PoMicroFrontend } from 'micro-frontend.react';

export const openManageAccessModal = (userId, employeeId, onSuccess) => {
	const rootElement = document.createElement('div');
	document.body.appendChild(rootElement);
	const appRoot = renderV2({
		children: (
			<PoMicroFrontend
				employeeId={employeeId}
				onClose={(changesSavedSuccessfully: boolean, emailWasUpdated: boolean) => {
					if (changesSavedSuccessfully && typeof onSuccess === 'function') {
						onSuccess(emailWasUpdated);
					}
					if (isEnabled('REACT_18_RENDER')) {
						appRoot.unmount();
					} else {
						ReactDOM.unmountComponentAtNode(rootElement);
					}
					document.body.removeChild(rootElement);
				}}
				route="/access-levels/assignment-modal"
				userId={userId}
			/>
		),
		attachedElement: rootElement,
	});
};
